import { render, staticRenderFns } from "./PageRightProtectionDetail.vue?vue&type=template&id=90d03876&scoped=true"
import script from "./PageRightProtectionDetail.vue?vue&type=script&lang=js"
export * from "./PageRightProtectionDetail.vue?vue&type=script&lang=js"
import style0 from "./PageRightProtectionDetail.vue?vue&type=style&index=0&id=90d03876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d03876",
  null
  
)

export default component.exports